export { default } from './ActivityOutcomesStatistic';
